export default __webpack_public_path__ + "static/media/open_banking.b63f2ced.jpg";